import {
  CLEAR_USER_ERROR,
  LOAD_USER_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
} from "app/utils/constants/usersConstant";

const INIT_STATE = {
  loading: false,
  error: null,
  userData: null,
  TotalPage: null,
};

export const userReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    //load user
    case LOAD_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
      };

    case LOAD_USER_FAIL:
      return {
        ...state,
        loading: false,
        userData: [],
        error: action.payload,
      };
    case CLEAR_USER_ERROR:
      return {
        ...state,
        loading: false,
        userData: [],
        error: null,
      };
    default:
      return state;
  }
};
